// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2fb1a2ab","977":"4fcb443c"}[chunkId] + ".chunk.js";
};